import { FC } from "react";
import classNames from "classnames";

import styles from "./index.less";

import BasicIcon from "../../assets/icons/basic.svg";
import PlusIcon from "../../assets/icons/plus.svg";
import ProIcon from "../../assets/icons/pro.svg";
import UltraIcon from "../../assets/icons/ultra.svg";

import { PricingPlanVersionEnum } from "../../types";

interface PlanResourceLabelProps {
  version: PricingPlanVersionEnum;
}

const PlanResourceLabel: FC<PlanResourceLabelProps> = ({ version }) => {
  return (
    <div className={styles.container}>
      {version === PricingPlanVersionEnum.BASIC && (
        <>
          <img
            src={BasicIcon}
            alt="Basic"
            style={{
              height: 20,
              width: 20,
            }}
          />
          <div className={classNames(styles.label, styles.basic)}>Basic</div>
        </>
      )}

      {version === PricingPlanVersionEnum.PLUS && (
        <>
          <img
            src={PlusIcon}
            alt="Plus"
            style={{
              height: 20,
              width: 20,
            }}
          />
          <div className={classNames(styles.label, styles.plus)}>Plus</div>
        </>
      )}

      {version === PricingPlanVersionEnum.PRO && (
        <>
          <img
            src={ProIcon}
            alt="Pro"
            style={{
              height: 20,
              width: 20,
            }}
          />
          <div className={classNames(styles.label, styles.pro)}>Pro</div>
        </>
      )}

      {version === PricingPlanVersionEnum.ULTRA && (
        <>
          <img
            src={UltraIcon}
            alt="Ultra"
            style={{
              height: 20,
              width: 20,
            }}
          />
          <div className={classNames(styles.label, styles.ultra)}>Ultra</div>
        </>
      )}
    </div>
  );
};

export default PlanResourceLabel;
